const defaultFetchOptions = {mode:'cors',credentials:'omit'};

const fetchers = {}
export function cachedFetchJsonFn(fetchOptions=defaultFetchOptions){
  const key = JSON.stringify(fetchOptions)
  return fetchers[key] = fetchers[key] || ((fetchCache = {})=>url=>fetchCache[url] || (fetchCache[url] = fetch(url,fetchOptions).then(r=>r.json())))()
}

export default cachedFetchJsonFn